import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import "./dropDownBlog.css";

const BlogCategoryDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const options = [
    { value: "",          label: "All" },
    { value: "trending",  label: "Trending"       },
    { value: "most_read", label: "Most Read"      },
  ];

  const selectedOption = options.find((opt) => opt.value === value) || options[0];

  const handleSelect = (optionValue) => {
    onChange({ target: { value: optionValue } });
    setIsOpen(false);
  };

  return (
    <div className="booking-dropdown-wrapper">
      <button
        className="dropdown-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="dropdown-label">{selectedOption?.label}</span>
        <ChevronDown
          size={18}
          className={`dropdown-chevron ${isOpen ? "open" : ""}`}
        />
      </button>

      {isOpen && (
        <div className="dropdown-menu">
          {options.map((option) => (
            <button
              key={option.value}
              className={`dropdown-option ${value === option.value ? "active" : ""}`}
              onClick={() => handleSelect(option.value)}
            >
              <span className="option-label">{option.label}</span>
              {value === option.value && (
                <span className="checkmark">✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlogCategoryDropdown;